function checkMarquee(el) {
  const label = el.querySelector('.custom-control-label')
  if (!label) return

  const overflow = label.scrollWidth - el.clientWidth
  if (overflow > 0) {
    label.style.setProperty('--marquee-distance', `-${overflow}px`)
    label.style.display = 'inline-block'
    label.style.whiteSpace = 'nowrap'
    label.style.animation = 'marquee-bounce 6s linear infinite'
  } else {
    label.style.removeProperty('--marquee-distance')
    label.style.display = ''
    label.style.whiteSpace = ''
    label.style.animation = ''
  }
}

export default {
  inserted(el) {
    el._marqueeTimer = setTimeout(() => checkMarquee(el), 150)
    el._marqueeObserver = new ResizeObserver(() => checkMarquee(el))
    el._marqueeObserver.observe(el)
  },
  unbind(el) {
    clearTimeout(el._marqueeTimer)
    if (el._marqueeObserver) {
      el._marqueeObserver.disconnect()
    }
  }
}
